import * as StateTypes from 'src/state/types';
import * as Observe from 'src/util/observe';

export const FeatureStatusesValue = Observe.Value<null | StateTypes.MercariFeatureStatusesType>(null);
export const FeatureStatusesFallback = Observe.React.WithFallback(FeatureStatusesValue);

export const StatBucketsAsyncValue = Observe.AsyncStateValue();
export const StatBucketsValue = Observe.Value<null | StateTypes.MercariStatBucketsType>(null);
export const StatBucketsFallback = Observe.React.WithFallback(StatBucketsValue);
